import React, { Component } from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import WithConsumer from '../../context/WithConsumer';
import { Link } from 'react-router-dom';

export default class PageContact extends Component {
	
	render () {
		
		let block 		= this.props.block;
				
		if (block) {
									
		    return (
			    
			    <div id={block.id} className={'c-page__block c-page__block--charcoal c-page__block--load-effect'}>
			    
			    	<div className="c-contact">
			    		<div className="l-grid">
			    			<div className="l-grid__col">
			    				<div className="c-contact__text c-load-fade" dangerouslySetInnerHTML={{ __html:block.text }}></div>
			    			</div>
			    		</div>
			    	</div>
			    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
